import classNames from 'classnames/bind';
import React from 'react';
import Icon, { ICONS } from '../Icon';
import styles from './ErrorContainer.module.scss';

const cx = classNames.bind(styles);

type ErrorContainerProps = {
  error: string;
};

const ErrorContainer = ({ error }: ErrorContainerProps): React.ReactElement => (
  <div className={cx('body')}>
    <Icon name={ICONS.Warning} />
    {error}
  </div>
);

export default ErrorContainer;
